import React from "react";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = ({ dataPoints = [], currencySymbol }) => {
  if (!dataPoints.length) return null;
  return (
    <div className="client-info-data-points-wrapper">
      {dataPoints.map(({ name, value, type }) => {
        const settingsProps = {
          label: name,
          value: value
        };

        return (
          <DataDisplay
            key={name}
            {...settingsProps}
            disableAnimation
            type={type}
            currency={currencySymbol}
          />
        );
      })}
    </div>
  );
};
